interface ICallbackArgs {
  canvas: HTMLCanvasElement
  ctx: CanvasRenderingContext2D
}

export function canvasDafeDatUrl(canvas: HTMLCanvasElement, type?: string, cb?: (args: ICallbackArgs) => void) {
  const copy = document.createElement('canvas')
  const ctx = copy.getContext('2d')!
  copy.width = canvas.width
  copy.height = canvas.height
  ctx.drawImage(canvas, 0, 0)
  if (cb) {
    cb({ canvas, ctx })
  }
  return copy.toDataURL(type)
}
